// extracted by mini-css-extract-plugin
export default {"projectCont":"ProjectsPageMain_projectCont__tQyTD"};